import { useMediaQuery } from '@mui/material';
import type { CreateOrderRequest, DiscountedPartPrice, ISO4217, SvtCreateOrderResponse } from '@partful/shared-types';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { device } from 'src/constants/mediaQueries';
import { CartEntry } from 'src/providers/ShoppingCart';
import { useTenant } from 'src/providers/Tenant';
import { AccountDetails, MutateAccountDetails } from 'src/providers/User/userDetails';
import { GA } from 'src/services/gtag';
import DesktopCheckout from './Desktop';
import MobileCheckout from './Mobile';

export interface CheckoutProps {
  cart: CartEntry[];
  orderNumber?: string;
  isOrderPOR: boolean;
  discountPercentage: number | undefined;
  currency: ISO4217;
  sendOrder: UseMutateAsyncFunction<AxiosResponse<SvtCreateOrderResponse>, unknown, CreateOrderRequest, unknown>;
  cartTotal: DiscountedPartPrice;
  currentPath: string;
  isFetching: boolean;
  goBack: () => void;
  defaultAccountDetails: MutateAccountDetails & AccountDetails;
  label1Key?: string;
  label2Key?: string;
  label3Key?: string;
  ctaKey?: string;
}

export default function Checkout(checkoutProps: CheckoutProps) {
  const tenant = useTenant();
  const isMobile = useMediaQuery(device.mobileOrTablet);
  const { orderNumber, currentPath, cartTotal, cart } = checkoutProps;

  useEffect(() => {
    if (!orderNumber) {
      GA.Ecommerce.beginCheckout(tenant, cart, cartTotal);
    }
  }, [cart, cartTotal, orderNumber, tenant]);

  if (orderNumber) return <Redirect to={`${currentPath}/thank-you`} />; // go to confirmation screen

  return isMobile ? (
    /* istanbul ignore next */ <MobileCheckout {...checkoutProps} />
  ) : (
    <DesktopCheckout {...checkoutProps} />
  );
}
